import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-obiettivi',
  templateUrl: './obiettivi.component.html',
  styleUrls: ['./obiettivi.component.css']
})
export class ObiettiviComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
